function switchTab() {
    $(".tab-switch-wrapper .tabs-wrapper .tab").click(function() {
      const tabId = $(this).attr('tab-i');
      const contentWrap = $(this).closest('.tab-switch-wrapper').find('.tab-content[tab-i="' + tabId + '"]');
      contentWrap.siblings(".tab-content").fadeOut(150).promise().done(function() {
        contentWrap.fadeIn(150);
      });
      
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
    });
  }
  if($(".tab-switch-wrapper").length) switchTab();